import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import logo from '../../images/favicon.png';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export default function MagicLogin() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) { setStatus('error'); setErrorMsg('No login token provided.'); return; }

    const doLogin = async () => {
      try {
        const res = await fetch(`${BASE}/auth/magic?token=${encodeURIComponent(token)}`);
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'Invalid or expired link');

        // Store JWT and user just like normal login
        localStorage.setItem('jwt_token', data.token);
        // Trigger a full reload so AuthProvider picks it up, then redirect
        window.location.href = data.user.role === 'client' ? '/client-portal' : '/portal';
      } catch (err) {
        setStatus('error');
        setErrorMsg(err.message);
      }
    };

    doLogin();
  }, []); // eslint-disable-line

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg)',
      padding: 16,
    }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <img src={logo} alt="Logo" style={{ width: '160px', height: '160px', objectFit: 'contain', marginBottom: '16px' }} />
          <h1 style={{ fontSize: 24, fontWeight: 800, marginBottom: 4, color: 'var(--text)' }}>Evercrest Publishing</h1>
          <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>Magic Link Sign-In</p>
        </div>

        <div className="card" style={{ padding: 32, textAlign: 'center' }}>
          {status === 'loading' && (
            <>
              <span className="spinner" style={{ width: 36, height: 36, margin: '0 auto 20px' }} />
              <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>Verifying your link, please wait…</p>
            </>
          )}
          {status === 'error' && (
            <>
              <XCircle size={48} color="var(--danger)" style={{ margin: '0 auto 16px' }} />
              <h2 style={{ fontSize: 18, fontWeight: 700, color: 'var(--danger)', marginBottom: 8 }}>Link Invalid or Expired</h2>
              <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 24 }}>{errorMsg}</p>
              <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} onClick={() => navigate('/login')}>
                Back to Login
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
